import type { Notificacao } from './notificacaoTypes';

/** Dia local `yyyy-mm-dd`. O aviso em tempo real nao traz `criadoEm`. */
export function dataIsoLocal(agora = new Date()): string {
  const mes = String(agora.getMonth() + 1).padStart(2, '0');
  const dia = String(agora.getDate()).padStart(2, '0');
  return `${agora.getFullYear()}-${mes}-${dia}`;
}

/** Extrai `yyyy-mm-dd` de um datetime da API (`2026-09-15T09:00:00`). */
export function dataIsoDeCriadoEm(criadoEm?: string | null): string | null {
  if (!criadoEm) return null;
  const dia = criadoEm.slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(dia) ? dia : null;
}

/**
 * Destino do toque no inbox da escola.
 * Sem `idPublicacao` nem `idAluno`, nao ha pagina util alem de marcar como lida.
 */
export function destinoNotificacao(
  n: Pick<Notificacao, 'idPublicacao' | 'idAluno' | 'idComentario' | 'criadoEm' | 'dataPublicacao' | 'idEvento' | 'dataEvento'>,
): string | null {
  if (n.idEvento != null && n.idEvento > 0) {
    const params = new URLSearchParams();
    const dia = n.dataEvento && /^\d{4}-\d{2}-\d{2}$/.test(n.dataEvento) ? n.dataEvento : dataIsoDeCriadoEm(n.criadoEm);
    if (dia) params.set('data', dia);
    params.set('idEvento', String(n.idEvento));
    return `/agenda?${params.toString()}`;
  }
  if (n.idPublicacao == null && n.idAluno == null) return null;
  const params = new URLSearchParams();
  if (n.idPublicacao != null) params.set('idPublicacao', String(n.idPublicacao));
  if (n.idAluno != null) params.set('idAluno', String(n.idAluno));
  const diaAtividade = n.dataPublicacao && /^\d{4}-\d{2}-\d{2}$/.test(n.dataPublicacao)
    ? n.dataPublicacao
    : null;
  const data = diaAtividade ?? dataIsoDeCriadoEm(n.criadoEm);
  if (data) params.set('data', data);
  if (n.idComentario != null && n.idComentario > 0) params.set('comentarios', '1');
  const q = params.toString();
  return q ? `/publicacoes?${q}` : '/publicacoes';
}
